import * as authActions from '../actions/authentication.actions';
import { Authentication } from '../model/authentication.model';

/**
 * Reducer handles authentication loading.
 */
export function authentication(state: Authentication = new Authentication(), action: authActions.Actions): Authentication  {
    switch (action.type) {
        case authActions.AUTHENTICATION_REQUEST:
            return {...state, loading: true};
        case authActions.AUTHENTICATION_SUCCESS:
            return {...state, loading: false};
        case authActions.AUTHENTICATION_ERROR:
            return {...state, loading: false, errorDescription: <string>action.payload};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/reducers/authentication.reducer.ts